const state = {
  token: sessionStorage.getItem('access_token') || null,
  userInfo: null,
  sendToken: '',
  clientUid: '',
  loading: false
};

export default state;
